import { render, staticRenderFns } from "./general-content-header.vue?vue&type=template&id=1e994579&scoped=true&"
import script from "./general-content-header.vue?vue&type=script&lang=js&"
export * from "./general-content-header.vue?vue&type=script&lang=js&"
import style0 from "./general-content-header.vue?vue&type=style&index=0&id=1e994579&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e994579",
  null
  
)

export default component.exports